import { AtlasCheckbox } from '@fuegokit/react';
import { Box, Text } from '@fuegokit/react';
import React from 'react';

import { Divider } from '../reusable/Divider';

interface CheckboxGroupLabelProps {
  workspaceName: string;
  isChecked: boolean;
  onClick: () => void;
}

export function CheckboxGroupLabel({
  workspaceName,
  isChecked,
  onClick,
}: Readonly<CheckboxGroupLabelProps>) {
  return (
    <Box
      sx={{
        paddingLeft: 1,
      }}
    >
      <AtlasCheckbox
        label={
          <Text fontSize="2" fontWeight="semibold" color="text.default">
            {workspaceName}
          </Text>
        }
        isChecked={isChecked}
        isIndeterminate
        onClick={onClick}
      />
      <Divider />
    </Box>
  );
}
